import styles from './products-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { ProductsStorePageProps } from './products-page.types'
import { PageContainer, ProductsTable } from 'components'
import { IconProducts, PageHeader, NoneLabel } from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { getMyStoreProductAddPath } from 'routes'
import { useParams } from 'react-router'

const ProductsPageComponent = (props: ProductsStorePageProps) => {
  const { className, style } = props
  const { storeId } = useParams<{ storeId?: string }>()

  const {
    routingStore: { push },
    userStore: { setManagementStoreId },
    storeProductsTableStore: {
      triggerSearch,
      catalogElementsTotalCount,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect
    }
  } = useRootStore()

  useEffect(() => {
    setManagementStoreId(storeId)
  }, [storeId, setManagementStoreId])

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const hasProducts = catalogElementsTotalCount > 0

  return (
    <PageContainer className={cl(styles.scrollable, styles.productsContainer ,className)} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconProducts,
            label: 'Products'
          }
        ]}
        buttons={[
          {
            preset: 'primary',
            disabled: false,
            onClick: () => push(getMyStoreProductAddPath(storeId)),
            children: 'Add a product'
          }
        ]}
        colorPreset='dark'
      />

      {!hasProducts ? (
        <NoneLabel colorPreset='dark' label='No products yet.' />
      ) : (
          <ProductsTable
            containerProps={{
              noBoxShadow: true,
              style: { marginTop: 15, minHeight: 230 }
            }}
            hideStoreColumn
            isColumnMarked={isColumnMarked}
            getSortDirection={getSortDirection}
            handleSortDirectionChange={handleSortDirectionChange}
            searchProps={searchProps}
            onSearchPropsChange={onSearchPropsChange}
            searchResults={searchResults}
            paginationInfo={paginationInfo}
            onPageSelect={onPageSelect}
          />
      )}
    </PageContainer>
  )
}

const ProductsStorePage = observer(ProductsPageComponent)
export { ProductsStorePage }
